<template>
  <UIButtonIcon
    :leading="XMarkIcon"
    variant="gray"
    fill="light"
    type="button"
    size="sm"
  />
</template>

<script setup lang="ts">
import { UIButtonIcon } from '@ui/buttons'

import { XMarkIcon } from '@heroicons/vue/24/outline'
</script>
